import React from 'react';

import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Dropdown, DropdownButton  } from 'react-bootstrap';

import es from '../../../lang/es';
import alertMessages from '../../../helpers/alertMessages';
import messages from '../../../constants/messages';
import { getApiPrefix } from '../../../helpers/authHelper';
import apiMethods from '../../../constants/apiMethods';
import api from '../../../helpers/api';

const HistoryLink = ({ proceeding, history }) => {
    //Manejo la apertura del link
    const handleOpen = async historyLink => {
        //Cargo espera
        alertMessages.waiting(messages.LOADING.GETTING_LINK);

        try{
            //Genero la data
            const params = {
                jurisdiction: proceeding.jurisdiction_id,
                proceeding: proceeding.procid,
                history: history.history.histid,
                link: historyLink.hiviid
            }
            //Genero request
            const response = await api.post(`${getApiPrefix()}${apiMethods.HISTORY_LINK}`, params);
            //Obtengo respuesta efectiva
            const { data } = response.data;
            //Tomo el link y lo abro
            window.open(data.url, "_blank");
            //Oculto espera
            alertMessages.close();
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto espera
            alertMessages.close();
            //Muestro error
            alertMessages.error(data.message);
        }
    }
    //Render
    return (
        <DropdownButton
            as={ButtonGroup}
            className="float-right ml-2"
            drop="up"
            title={
                <>
                <FontAwesomeIcon icon={ faLink } /> <strong>{ es.HISTORY_LINK.toUpperCase() }</strong>
                </>
            }
            variant="info"
        >
            {
                history.history.vinculos.map((historyLink, index) => (
                    <Dropdown.Item
                        key={`hv${index}`}
                        onClick={() => handleOpen(historyLink)}
                    >
                        { `${historyLink.fuero}: `} <strong>{historyLink.numero}</strong> - {historyLink.descripcion}
                    </Dropdown.Item>
                ))
            }
        </DropdownButton>
    );
};

export default HistoryLink;